import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";

const data = [
  { name: "2012", value: 1263 },
  { name: "2013", value: 1350 },
  { name: "2014", value: 4920 },
  { name: "2015", value: 9010 },
  { name: "2016", value: 23250 },
  { name: "2017", value: 58591 },
  { name: "2018", value: 108000 },
  { name: "2019", value: 133006 },
  { name: "2020", value: 151632 },
  { name: "2021", value: 180575 },
  { name: "2022", value: 211273 },
  { name: "2023", value: 270429 },
  { name: "2024", value: 356966 },
  { name: "2025", value: 492614 },
  { name: "2026", value: 635472 },
  { name: "2027", value: 749857 },
  { name: "2028", value: 877332 },
  { name: "2029", value: 1013319 },
  { name: "2030", value: 1114651 },
  { name: "2031", value: 1203823 },
  { name: "2032", value: 1300128 },
];

const renderCustomTooltip = ({ payload }) => {
  if (payload && payload.length > 0) {
    const dataPoint = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p>{dataPoint.name}</p>
        <p style={{ color: "rgb(53, 162, 235)" }}>{dataPoint.value}</p>
      </div>
    );
  }
  return null;
};

const InfrastructureExpansionChartRe = () => {
  return (
    <div>
      <p style={{ textAlign: "center", marginBottom: "5px", fontSize: "14px", paddingLeft: "25px" }}>
        U.S. Wireless Cell Site Projections
        <sup style={{ fontSize: "10px" }}>3</sup>
      </p>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name"></XAxis>
          <YAxis></YAxis>
          <Tooltip content={renderCustomTooltip} />
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="rgb(53, 162, 235)"
            animationBegin={500}
            animationDuration={1000}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default InfrastructureExpansionChartRe;
